module.exports = __webpack_public_path__ + "static/media/和1629适老公寓.9894aabf.pdf";